import { render } from "./PrivacyPolicyContent.vue?vue&type=template&id=771129fe"
import script from "./PrivacyPolicyContent.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__